import React from 'react';
export const SlovHeader = () =>
{
    return(<h1 id = "slov_header">DOOMINATE (CYBERBOX)</h1>);
} 